import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('AppSplashScreen'):_c(VMain,{staticStyle:{"height":"100%","min-width":"300px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }